import { Card, CardContent, Box } from '@mui/material';
import { useEffect, useState } from 'react';
import Projects from './contents/Projects';
import Deliverables from '../../../deliverables/Deliverables';
import Clins from './contents/Clins';
import MasterSchedule from '../../../master-schedule/MasterSchedule';
import ApprovalQueue from '../../../approvalQueue/ApprovalQueue';


const QuickViewCard = (props) => {
  const [content, setContent] = useState(null);

  useEffect(() => {
    switch (props.type) {
      case 'Projects': {
        setContent(<Projects />);
        break;
      }
      case 'Deliverables': {
        setContent(<Deliverables readOnly />);
        break;
      }
      case 'Clins': {
        setContent(<Clins />);
        break;
      }
      case 'Master Schedule': {
        setContent(<MasterSchedule hideHeader={props.hideHeader} />);
        break;
      }
      case 'Approval Queue': {
        setContent(
          <ApprovalQueue
            hideHeader={props.hideHeader}
            fixedPageSize={props.fixedPageSize}
          />,
        );
        break;
      }
      default:
        setContent(null);
    }
  }, [props.type, props.hideHeader, props.fixedPageSize]);

  return (
    <Card
      sx={{
        pt: 2,
        px: 2,
        pb: 2,
        height: '100%',
      }}
    >
      <CardContent sx={{ width: '100%', height: '100%', overflow: 'auto', }}>
        <Box
          sx={{
            width: '100%',
            height: '95%',
            overflow: 'auto',
          }}
        >
          {content}
        </Box>
      </CardContent>
    </Card>
  );
};

export default QuickViewCard;
